import React from "react";
import { twMerge } from "tailwind-merge";

export default function Label(props) {
  return (
    <label {...props} className={twMerge("text-left block", props.className)} />
  );
}
